import { Link } from 'react-router'
import React from 'react'
import { Stack } from '@mui/system'
import IssueTypeLabels, { HasWarrantLabel, KVLabel } from '../../components/entities/IssueTypeLabels'
import { GridRenderCellParams } from '@mui/x-data-grid/models'
import { EnrichedNewsItem } from './NewsItemsGrid'

const DateGroupItem = (props: GridRenderCellParams<EnrichedNewsItem> & { isSlim?: boolean }) => {
    const { row, isSlim } = props

    return (
        <>
            <div
                style={{
                    fontWeight: 400,
                    display: 'flex',
                    alignItems: isSlim ? undefined : 'center',
                    minHeight: '40px',
                }}
            >
                <Stack
                    direction='row'
                    spacing={2}
                    sx={{
                        alignItems: isSlim ? undefined : 'center',
                        justifyContent: 'space-between',
                        display: 'flex',
                        width: isSlim ? undefined : '200px',
                    }}
                >
                    {!isSlim && (
                        <Link to={`/companies/${row.companyId}`}>
                            <span style={{ marginLeft: 30 }}>{row.symbol}</span>
                        </Link>
                    )}
                    <Stack
                        direction='row'
                        spacing={1}
                        sx={{
                            alignItems: isSlim ? undefined : 'center',
                            justifyContent: 'flex-start',
                            display: 'flex',
                            width: '65px',
                        }}
                    >
                        {row.issueData ? (
                            <IssueTypeLabels
                                displayGELabel
                                hasWarrants={!!row.issueData.hasWarrants}
                                isRto={!!row.issueData.rto}
                                isSpac={!!row.issueData.spac}
                                issueType={row.issueData.type}
                                sharesInUnit={row.issueData.sharesInUnit}
                                unitExtraContent={row.issueData.unitExtraContent}
                            />
                        ) : row.convertibleData ? (
                            <KVLabel />
                        ) : (
                            <HasWarrantLabel />
                        )}
                    </Stack>
                </Stack>
            </div>
        </>
    )
}

export default DateGroupItem
